import helperStyles from "@src/components/helpers.module.scss";
import React from "react";

export const Local: React.FC = () => {
	return (
		<div className={helperStyles.iconContainer}>
			<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 48 48">
				<defs>
					<mask id="IconifyId190a1808e514992831">
						<g fill="none" stroke="#fff" strokeLinejoin="round" strokeWidth="4">
							<path
								strokeLinecap="round"
								d="M9.858 32.757C6.238 33.843 4 35.343 4 37c0 3.314 8.954 6 20 6s20-2.686 20-6c0-1.657-2.239-3.157-5.858-4.243"
							/>
							<path
								fill="#A09FA7"
								d="M24 35s13-8.496 13-18.318C37 9.678 31.18 4 24 4S11 9.678 11 16.682C11 26.504 24 35 24 35Z"
							/>
							<path fill="#A09FA7" d="M24 22a5 5 0 1 0 0-10a5 5 0 0 0 0 10Z" />
						</g>
					</mask>
				</defs>
				<path fill="#A09FA7" d="M0 0h48v48H0z" mask="url(#IconifyId190a1808e514992831)" />
			</svg>
		</div>
	);
};
